import { Box, Paper, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { GridContainer, GridItem, InformationField } from '../../../../components/shared';

const Field = ({ label, value }) => (
  <>
    <InformationField value={label.toUpperCase()} variant="subtitle2" />
    <InformationField value={value ?? '—'} variant="subtitle1" />
  </>
);

const FieldItem = ({ label, value, minWidth }) => (
  <GridItem xs={12} sm="auto" sx={{ minWidth: { sm: minWidth }, width: 'auto', flex: 'none' }}>
    <Field label={label} value={value} />
  </GridItem>
);

const MonthlyPostingDetailTopPanel = ({ x3ProductName, dateRange, postingDate, finalizedBy, finalizedTimestamp }) => (
  <Box
    component={Paper}
    sx={{
      mb: 2,
      border: '1px solid',
      borderColor: 'grey.200',
      borderRadius: 1,
      backgroundColor: 'common.white',
      position: 'relative',
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        top: 8,
        right: 16,
        color: 'grey.800',
        fontSize: '11px',
        fontStyle: 'italic',
        display: 'flex',
        alignItems: 'center',
        zIndex: 1,
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: 14, mr: 0.5 }} />
      <Typography variant="caption" component="span">
        Excluding Standalone Sub-Locations
      </Typography>
    </Box>
    <GridContainer data-testid="info-pad" spacing={2} px={3} py={1} display="flex" justifyContent="flex-start">
      <FieldItem label="X3 Product Name" value={x3ProductName} minWidth="160px" />
      <FieldItem label="Date Range" value={dateRange} minWidth="240px" />
      <FieldItem label="Posting Date" value={postingDate} minWidth="160px" />
      <FieldItem label="Finalized By" value={finalizedBy} minWidth="190px" />
      <FieldItem label="Finalized Timestamp" value={finalizedTimestamp} minWidth="250px" />
    </GridContainer>
  </Box>
);

export default MonthlyPostingDetailTopPanel;
